import React from 'react'
import './footer.css'
function Footer() {
  return (
    <div className="footer">
      dev by 🛠 Diego Nonato 💕
    </div>
  )
}

export default Footer
